import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useSite } from "@/context/SiteContext";

export function useCms(collection, fallback) {
  const [data, setData] = useState(fallback);
  const [saving, setSaving] = useState(false);
  const { reload } = useSite();

  const load = useCallback(() => {
    api.get(`/admin/cms/${collection}`).then((r) => setData(r.data && (Array.isArray(r.data) || Object.keys(r.data).length) ? r.data : fallback)).catch(() => {});
  }, [collection]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { load(); }, [load]);

  const save = async (payload = data) => {
    setSaving(true);
    try {
      await api.put(`/admin/cms/${collection}`, payload);
      toast.success("Saved — website updated");
      reload();
      load();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };
  return { data, setData, save, saving, reload: load };
}
